export class DateHelper {
  public static toLocalISOString(date: Date | null): string | null {
    if (!date) return null;
    const pad = (n: number) => n.toString().padStart(2, '0');

    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
      `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    );
  }

  public static endOfBusinessDay(date: Date): Date {
    date.setDate(date.getDate() + 1);
    date.setHours(4, 30, 0, 0);
    return date;
  }

  public static getTimezoneAbbreviation(date: Date): string {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZoneName: "short"
    });

    const parts = formatter.formatToParts(new Date(date));
    const tz = parts.find(p => p.type === "timeZoneName");
    return tz?.value ?? "";
  }
}
